import 'twin.macro';

import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import tw from 'twin.macro';

import { useGetCurrencyQuery } from '@/app/api/currency';
import { Caption } from '@/components';

const convert = data => {
  if (data) {
    const newArray = [];
    data?.map(item => {
      item.bosname === 'SELL' &&
        newArray.push({ valcode: item.valcode, sell: item.rate, buy: null, ratedt: item.ratedt });
      item.bosname === 'BUY' &&
        newArray.map(i => {
          if (item.valcode === i.valcode) i.buy = item.rate;
        });
      return item;
    });
    return newArray;
  }
};
function CurrencyTable() {
  const [convertedData, setConvertedData] = useState(null);

  const { data } = useGetCurrencyQuery();
  useEffect(() => {
    data?.data?.length > 0 && setConvertedData(convert(data?.data));
  }, [data]);

  return convertedData ? (
    <>
      <div tw='bg-[#333333] flex p-2 rounded-xl sm:gap-0 gap-2 '>
        <Caption
          text={`Курсы валют на ${new Date(data?.data[0]?.ratedt).toLocaleString()}`}
          twStyle={tw`lg:text-[11px] sm:text-[5px] lg:max-w-[50px] sm:max-w-[50px]`}
        />
        <div tw='ml-5 gap-1 w-full'>
          {convertedData ? (
            convertedData?.map(item => (
              <div tw='flex justify-between' key={item?.sell}>
                <Caption text={`${item?.valcode} / KZT`} twStyle={tw`lg:text-[11px] sm:text-[5px] p-0 m-0`} />
                <Caption text={`${item?.sell}`} twStyle={tw`lg:text-[11px] sm:text-[5px] p-0 m-0`} />
                <Caption text={`${item?.buy}`} twStyle={tw`lg:text-[11px] sm:text-[5px] p-0 m-0`} />
              </div>
            ))
          ) : (
            <>
              <Caption text={'Произошла ошибка при загрузке'} />
            </>
          )}
          {/* <Caption text={'EUR / KZT'} twStyle={tw`lg:text-[10px] sm:text-[5px]`} />
      <Caption text={'498.00'} twStyle={tw`lg:text-[10px] sm:text-[5px]`} />
      <Caption text={'505.00'} twStyle={tw`lg:text-[10px] sm:text-[5px]`} />
      <Caption text={'RUB / KZT'} twStyle={tw`lg:text-[10px] sm:text-[5px]`} />
      <Caption text={'5.50'} twStyle={tw`lg:text-[10px] sm:text-[5px]`} />
      <Caption text={'7.00'} twStyle={tw`lg:text-[10px] sm:text-[5px]`} /> */}
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}

export default CurrencyTable;
